import DepartmentInfo from './info';

export default [
  {
    path: '/index/:id',
    name: 'Index',
    component: DepartmentInfo,
    meta: {
      title: '校区信息-编辑',
    },
  },
];



// WEBPACK FOOTER //
// ./src/views/Index/index.js